module.exports = __webpack_public_path__ + "static/media/YB5F01_3.3c2294a1.jpg";